export const downloadApk = async (product) => {
  let url = product.apk.url
  let filename = product.apk.filename

  if (product.apk.manifestUrl) {
    try {
      const response = await fetch(product.apk.manifestUrl, { cache: 'no-store' })
      if (response.ok) {
        const manifest = await response.json()
        url = manifest.url || url
        filename = manifest.filename || filename
      }
    } catch (error) {
      console.warn('无法读取 Android 最新版本信息，使用默认下载地址', error)
    }
  }

  const link = document.createElement('a')
  link.href = url
  link.download = filename
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}
